import React from "react";
import Form from "app/components/common/Form";

function SalonArtistForm(props) {
  const { values } = props;

  return (
    <div className="space-y-2">
      <Form.Row>
        <Form.Col>店舗名</Form.Col>
        <Form.ColGrow>{values?.name}</Form.ColGrow>
      </Form.Row>
      <Form.Row>
        <Form.Col>店舗名（フリガナ）</Form.Col>
        <Form.ColGrow>{values?.nameKana}</Form.ColGrow>
      </Form.Row>
      <Form.Row>
        <Form.Col>代表者</Form.Col>
        <Form.ColGrow>
          <Form.Row>
            <Form.Col className="basis-1 pr-2">姓</Form.Col>
            <Form.ColGrow>{values?.picLastName}</Form.ColGrow>
            <Form.Col className="basis-1 pr-2">名</Form.Col>
            <Form.ColGrow>{values?.picFirstName}</Form.ColGrow>
          </Form.Row>
        </Form.ColGrow>
      </Form.Row>
      <Form.Row>
        <Form.Col>電話番号</Form.Col>
        <Form.ColGrow>{values?.telephone}</Form.ColGrow>
      </Form.Row>
      <Form.Row>
        <Form.Col>メールアドレス</Form.Col>
        <Form.ColGrow>{values?.email}</Form.ColGrow>
      </Form.Row>
      <Form.Row>
        <Form.Col>住所</Form.Col>
        <Form.ColGrow>
          <Form.Row>
            <Form.Col>{values?.postalCode}</Form.Col>
          </Form.Row>
          <Form.Row>
            <Form.Col>{values?.address}</Form.Col>
          </Form.Row>
        </Form.ColGrow>
      </Form.Row>
      <Form.Row>
        <Form.Col>Niita契約</Form.Col>
        <Form.ColGrow>{values?.niitaContract ? "あり" : "なし"}</Form.ColGrow>
      </Form.Row>
    </div>
  );
}
export default SalonArtistForm;
